<div class="bendix_data_extraction_disclaimer_popup">
    <div class="header_section">
        <button class="close-btn" aria-label="close dialog" (click)="closeButton()">
            <img src="/icons/close-light-grey.svg" alt="" />
        </button>
    </div>
    <mat-dialog-content class="general-condition-content">
        <p class="title">{{'bendix_data_extraction_disclaimer_popup.title'|cxTranslate}}</p>
        <p>{{'bendix_data_extraction_disclaimer_popup.p1'|cxTranslate}}</p>
        <p class="mt-2">{{'bendix_data_extraction_disclaimer_popup.p2'|cxTranslate}}</p>
        <p class="mt-2 mb-0">{{'bendix_data_extraction_disclaimer_popup.attention'|cxTranslate}}</p>
        <p>{{'bendix_data_extraction_disclaimer_popup.p3'|cxTranslate}}</p>
        <p class="mt-2">{{'bendix_data_extraction_disclaimer_popup.p4'|cxTranslate}}</p>
        <p class="mt-2">
            <strong>{{'bendix_data_extraction_disclaimer_popup.p5_1'|cxTranslate}}</strong>
            <u>{{'bendix_data_extraction_disclaimer_popup.p5_2'|cxTranslate}}</u>
            <strong>{{'bendix_data_extraction_disclaimer_popup.p5_3'|cxTranslate}}</strong>
            {{'bendix_data_extraction_disclaimer_popup.p5_4'|cxTranslate}}
        </p>
        <p class="mt-2">{{'bendix_data_extraction_disclaimer_popup.p6'|cxTranslate}}</p>

        <p class="mt-2 mb-0"><strong>{{'bendix_data_extraction_disclaimer_popup.p7'|cxTranslate}}</strong></p>
        <li>{{'bendix_data_extraction_disclaimer_popup.p7_1'|cxTranslate}}</li>

        <p class="mt-2 mb-0"><strong>{{'bendix_data_extraction_disclaimer_popup.p8'|cxTranslate}}</strong></p>
        <li>{{'bendix_data_extraction_disclaimer_popup.p8_1'|cxTranslate}}
            <strong><u>{{'bendix_data_extraction_disclaimer_popup.p8_2'|cxTranslate}}</u></strong>
            {{'bendix_data_extraction_disclaimer_popup.p8_3'|cxTranslate}}
        </li>

        <p class="mt-3"><strong>
                {{'bendix_data_extraction_disclaimer_popup.note'|cxTranslate}}
            </strong></p>

        <p class="mt-3">{{'bendix_data_extraction_disclaimer_popup.p9'|cxTranslate}}</p>

    </mat-dialog-content>
    <mat-dialog-actions>
        <button (click)="accept()" class="mat-raised-button mat-primary mat-accept">{{
            'bendix_data_extraction_disclaimer_popup.accept' |
            cxTranslate }}</button>
    </mat-dialog-actions>
</div>